module.exports = __webpack_public_path__ + "static/img/about.1bc5ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/static-css/img/about-us/about.jpg
// module id = Elb3
// module chunks = 19